import { Button, DataHeader, DataSource, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMarketingPlan extends Layout {
    buttonAddActivity: Button;
    dataheaderDataheader: DataHeader;
    panelMarketingPlan: Panel;
    sourceMarketPlan: DataSource;
    sourceMarketPlanDetail: DataSource;
    tableMarketPlanDetail: Table;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
